const SI_PREFIXES = [
  { value: 1, symbol: '' },
  { value: 1e3, symbol: 'k' },
  { value: 1e6, symbol: 'M' },
  { value: 1e9, symbol: 'G' },
  { value: 1e12, symbol: 'T' },
  { value: 1e15, symbol: 'P' },
  { value: 1e18, symbol: 'E' },
];

export const toFloatOrNull = (str) => {
  const number = parseFloat(str);
  return isNaN(number) ? null : number;
};

export const toNumberOrNull = (str) => {
  const number = parseInt(str);
  return isNaN(number) ? null : number;
};

export const isBetween = (value, start, end) => {
  const val = Number.parseFloat(value),
    startVal = Number.parseFloat(start),
    endVal = Number.parseFloat(end);
  return val >= startVal && val <= endVal;
};

export const percentage = (value, percentage) => {
  if (!percentage) return 0;
  return (value * percentage) / 100;
};

export const abbreviateNumber = (number) => {
  if (number === 0) return number;

  const tier = SI_PREFIXES.filter((n) => number >= n.value).pop();
  const numberFixed = (number / tier.value).toFixed(1);

  return `${numberFixed}${tier.symbol}`;
};

export const precision = (a) => {
  if (isNaN(a)) return 0;
  const split = a.toString().split('.');
  if (split.length > 1) {
    return split[1].length;
  }
};
